import React, { Component } from 'react';
import { Tooltip } from 'reactstrap';
import App_data from '../views/config/App_data';
export default class TooltipItem extends Component {
  constructor(props) {
    super(props);
    this.state = { tooltipOpen: false };
  }
  onTooltipToggle = async () => {
    this.setState({ tooltipOpen: !this.state.tooltipOpen });
  };
  render() {
    const { tooltipOpen } = this.state;
    const { content, place_tip, tooltipId, isTooltipIcon = true, width = '18' } = this.props;
    return (
      <span>
        {isTooltipIcon && (
          <img
            src={`${App_data.frontend_url}/img/dashboard/info_icon.svg`}
            id={`Tooltip-${tooltipId}`}
            alt='tooltipIcon'
            width={width}
          />
        )}
        <Tooltip
          placement={place_tip}
          isOpen={tooltipOpen}
          target={`Tooltip-${tooltipId}`}
          toggle={this.onTooltipToggle}
        >
          <p className='tooltip_text'>{content}</p>
        </Tooltip>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/Tooltip.js